(function () {
  const giftVariantId = 57238149857604;
  const root = window.Shopify?.routes?.root || '/';
  let pending;
  let timer;
  let preparingCheckout = false;

  async function cartRequest(path, options) {
    const response = await fetch(root + path, options);
    if (!response.ok) throw new Error('Cart request failed: ' + response.status);
    return response.json();
  }

  function readCart() {
    return cartRequest('cart.js');
  }

  async function refreshCart(cart) {
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelector('cart-drawer .drawer__inner')?.classList.toggle('is-empty', cart.item_count === 0);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-gift', cartData: cart });
    }
    if (cart.item_count === 0) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const response = await fetch(root + 'cart?section_id=cart-drawer');
        if (response.ok) {
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const emptyDrawer = html.querySelector('cart-drawer');
          if (emptyDrawer) drawer.replaceWith(emptyDrawer);
        }
      }
    }
    const footer = document.querySelector('#main-cart-footer .js-contents');
    if (footer) {
      const response = await fetch(root + 'cart?section_id=main-cart-footer');
      if (response.ok) {
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('#main-cart-footer .js-contents');
        if (updated) footer.innerHTML = updated.innerHTML;
      }
    }
  }

  async function synchronize() {
    if (preparingCheckout) return readCart();
    if (pending) return pending;
    pending = (async function () {
      let cart = await readCart();
      const otherItems = cart.items.some((item) => item.variant_id !== giftVariantId);
      const gift = cart.items.find((item) => item.variant_id === giftVariantId);
      if (otherItems && !gift) {
        await cartRequest('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1 }] }),
        });
      } else if (gift && (!otherItems || gift.quantity !== 1)) {
        await cartRequest('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: otherItems ? 1 : 0 }),
        });
      } else {
        return cart;
      }
      cart = await readCart();
      await refreshCart(cart);
      return cart;
    })().finally(() => { pending = null; });
    return pending;
  }

  function schedule() {
    if (preparingCheckout) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      synchronize().catch((error) => console.error('E-book panier :', error));
    }, 250);
  }

  async function prepareCheckout() {
    preparingCheckout = true;
    clearTimeout(timer);
    if (pending) await pending;
    let cart = await readCart();
    const updates = {};
    cart.items.forEach((item) => {
      if (String(item.variant_id) === String(giftVariantId)) updates[item.key] = 0;
    });
    if (Object.keys(updates).length) {
      cart = await cartRequest('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }
    if (cart.items.some((item) => String(item.variant_id) === String(giftVariantId))) {
      throw new Error('Gift still present in checkout cart');
    }
    return cart;
  }

  function resume() {
    preparingCheckout = false;
    schedule();
  }

  window.PuffistaGift = { synchronize, prepareCheckout, resume };
  window.addEventListener('pageshow', resume);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'auto-gift') schedule();
    });
  }
})();
